module.exports = (__webpack_require__(78))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 52
// module chunks = 0